module.exports = __webpack_public_path__ + "static/logo-d62a1c6cc6ffb4600077b583c56b33f0.png";